import React from 'react';
import { Table, Card, Space } from 'antd';
import { PlayCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { updateCurrentRecording } from '../Feature/RecordingsSlice';
import moment from 'moment';
import './RecordingTable.css';

export const RecordingTable = ({
    recordings,
    columns: customColumns,
    rowSelection,
    onPlayRecording
}) => {
    const dispatch = useDispatch();

    const handlePlayRecording = (recording) => {
        dispatch(updateCurrentRecording(recording));
        if (onPlayRecording) {
            onPlayRecording(recording);
        }
    };

    const playColumn = {
        title: 'Listen',
        key: 'file_uri',
        render: (text, record) => {
            return (
                <Card className="recording-card"
                    actions={[
                        <PlayCircleOutlined key="play" onClick={() => handlePlayRecording(record)} />,
                        <a href={record.file_uri} download><DownloadOutlined key="download" /></a>
                    ]}
                >
                </Card>
            );
        },
        responsive: ["sm"]
    };

    const mobileCardColumn = {
        title: 'Recording',
        key: 'file_uri_mobile',
        render: (text, record) => {
            return (
                <Card
                    actions={[
                        <PlayCircleOutlined key="play" onClick={() => handlePlayRecording(record)} />,
                        <a href={record.file_uri} download><DownloadOutlined key="download" /></a>
                    ]}
                    title={record.original_name}
                >
                    <Card.Meta
                        description={`Recorded on ${moment(record.creation_date_time).utc().format('YYYY-MM-DD')}`}
                    />
                </Card>
            );
        },
        responsive: ["xs"]
    };

    const columns = [
        {
            title: 'Original Name',
            dataIndex: 'original_name',
            key: 'original_name',
            responsive: ["sm"]
        },
        playColumn,
        ...customColumns,
        mobileCardColumn
    ];

    return (
        <Table
            columns={columns}
            dataSource={recordings}
            rowKey="id"
            rowSelection={rowSelection}
        />
    );
};
